/* eslint-disable no-unused-vars */
import { LockClosedIcon } from '@heroicons/react/solid';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import logo from '../../components/layout/logo_new.png';
import { newPasswordAction } from '../../redux/actions/userActions';
import { validatePassword } from '../../utils/password';

const NewPassword = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useParams();
  const { t } = useTranslation();

  const choosePassword = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    const newError = validatePassword(newPassword, confirmPassword);
    setError(newError);
  };

  const chooseConfirmPassword = (e) => {
    const newPassword = e.target.value;
    setConfirmPassword(newPassword);
    const newError = validatePassword(newPassword, confirmPassword);
    setError(newError);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      if (password !== confirmPassword) {
        return;
      }
      await dispatch(newPasswordAction(password, confirmPassword, token));
      navigate('/login');
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="h-screen flex justify-center items-center">
      <div className="w-screen h-screen flex items-center justify-center">
        <form
          onSubmit={handleFormSubmit}
          className="bg-white shadow-lg rounded-2xl flex flex-col space-y-8 justify-around pt-16 px-16 pb-8  border-grey-input_border border-2"
        >
          <div className="flex w-full justify-center min-w-[300px]">
            <Link to={'/login'}>
              <img className="mx-auto w-[200px]" src={logo} />
            </Link>
          </div>
          <div className="relative flex flex-col">
            <label className="text-sm my-2">{t('auth.password')}: </label>
            <input
              type="password"
              onChange={choosePassword}
              className="placeholder-grey-medium text-sm rounded-lg shadow-md border-none py-2 px-3 pl-10"
              placeholder={t('auth.login_register_enter_password')}
            />
            <LockClosedIcon className="absolute w-5 top-8 pt-2 left-2" />
          </div>
          <div className="relative flex flex-col">
            <label className="text-sm my-2">
              {t('auth.login_register_password_confirm')}:{' '}
            </label>
            <input
              type="password"
              onChange={chooseConfirmPassword}
              className="placeholder-grey-medium text-sm rounded-lg shadow-md border-none py-2 px-3 pl-10"
              placeholder={t('auth.login_register_password_confirm')}
            />
            <LockClosedIcon className="absolute w-5 top-8 pt-2 left-2" />
          </div>
          <button
            disabled={
              !password.length ||
              !confirmPassword.length ||
              password !== confirmPassword
            }
            type="submit"
            className="rounded-lg group bg-sky text-white px-2 shadow-md py-1 disabled:bg-grey-medium disabled:hover:bg-grey-medium hover:bg-sky-dark hover:shadow-md transition-colors"
          >
            <p>Indienen</p>
          </button>

          {/* Show error */}
          <p className="text-danger h-6 w-full">{error}</p>
        </form>
      </div>
    </div>
  );
};

export default NewPassword;
